import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import { deleteUsersProfilePhoto } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import appStore from "State/Store";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useDeleteProfilePhotoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      deleteUsersProfilePhoto(),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      // The context switcher shows per-persona avatars from the contexts query.
      queryClient.invalidateQueries({ queryKey: contextsKeys.all });
      appStore.store.dispatch(getUserInfoAsync.request(undefined));
      onSuccess?.();
    },
    onError,
  });
};
